document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.createElement('div');
  overlay.className = 'lightbox-overlay';
  overlay.innerHTML = '<img src="" alt="">';
  document.body.appendChild(overlay);

  const lightboxImg = overlay.querySelector('img');

  function attachLightbox() {
    document.querySelectorAll('.image-block__image').forEach(img => {
      if (img.dataset.lightboxAttached) return;
      img.dataset.lightboxAttached = 'true';
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function() {
        const src = this.src.replace(/_(small|medium|large|compact|grande|1024x1024|800x|600x)\./g, '.').split('?')[0];
        lightboxImg.src = src;
        overlay.classList.add('active');
      });
    });
  }

  attachLightbox();
  setTimeout(attachLightbox, 1500);

  overlay.addEventListener('click', function() {
    overlay.classList.remove('active');
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') overlay.classList.remove('active');
  });
});
